<i18n>
{
    "en": {
        "contact": {

            "email": "Email Address",
            "name": "Name",
            "title": "Message Subject",
            "content": "Message Content",
            "send": "Send Message",
            "placeholders": {
                "name": "Enter Your Name",
                "email": "Enter Your Email Address",
                "title": "Enter Message Subject",
                "content": "Enter Message Content"
            }
        }
    }
}
</i18n>
<template>
  <!-- <v-card> -->
  <div class="form-st mb-4">
    <form class="">
      <v-row>
        <v-col cols="12">
          <label class="label mb-1 mt-1">
            Contact Name: <span class="label-red">*</span></label
          >
          <v-text-field
            v-model="contactName"
            color="white"
            hide-details
            outlined
            :label="$t('contact.name')"
            :placeholder="$t('contact.placeholders.name')"
          />
        </v-col>
        <v-col cols="12">
          <label class="label mb-1 mt-1">
            Contact Email-ID: <span class="label-red">*</span></label
          >
          <v-text-field
            v-model="contactEmail"
            color="white"
            hide-details
            outlined
            :label="$t('contact.email')"
            :placeholder="$t('contact.placeholders.email')"
          />
        </v-col>
        <v-col cols="12">
          <label class="label mb-1 mt-1">
            Email Subject: <span class="label-red">*</span></label
          >
          <v-text-field
            v-model="subject"
            color="white"
            hide-details
            outlined
            :label="$t('contact.title')"
            :placeholder="$t('contact.placeholders.title')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <label class="label mb-1 mt-1">
            Email Content: <span class="label-red">*</span></label
          >
          <v-textarea
            v-model="contentBody"
            color="white"
            rows="4"
            filled
            hide-details
            no-resize
            auto-grow
            outlined
            :label="$t('contact.content')"
            :placeholder="$t('contact.placeholders.content')"
          />
        </v-col>
      </v-row>
      <div class="contact-actions d-flex mt-4">
        <v-btn
          block
          x-large
          tile
          color="primary"
          :href="
            `mailto:senthil@four-seasons.in;?subject=` +
              subject +
              ` ` +
              contactName +
              ` ` +
              contactEmail +
              `&body=` +
              contentBody
          "
        >
          <span>{{ $t("contact.send") }}</span>
          <v-icon class="ms-3">mdi-arrow-{{ isRtl ? "left" : "right" }}</v-icon>
        </v-btn>
      </div>
    </form>
  </div>
  <!-- </v-card> -->
</template>

<script>
import GlobalComputed from "@/helpers/global-computed";
//import axios from 'axios';
export default {
  computed: {
    ...GlobalComputed,
  },
  data() {
    return {
      contactName: "",
      contactEmail: "",
      subject: "",
      contentBody: "",
    };
  },
  methods: {},
};
</script>

<style scoped>
.label {
  color: rgb(255, 255, 255) !important;
  opacity: 1;
}
.label-red {
  color: rgb(199, 46, 0) !important;
}
</style>
